(function (win, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (win && !win.K2ShippingDestination) win.K2ShippingDestination = api.create(win);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var KEY = 'k2_shipping_destination';
  function normalize(value) {
    if (typeof value === 'string') { try { value = JSON.parse(value); } catch (error) { return null; } }
    if (!value || typeof value !== 'object') return null;
    var country = String(value.country || '').trim().toUpperCase();
    var zip = String(value.zip || '').trim();
    if (country === 'US') {
      if (!/^\d{5}(?:-\d{4})?$/.test(zip)) return null;
      var province = String(value.province || '').trim().toUpperCase().replace(/^US-/, '');
      return { country: 'US', zip: zip.slice(0, 5), province: /^[A-Z]{2}$/.test(province) ? province : '' };
    }
    if (country === 'OTHER') return { country: 'OTHER', zip: zip.slice(0, 20), province: '' };
    return null;
  }
  function clone(value) { return value ? { country: value.country, zip: value.zip, province: value.province } : null; }
  function signature(value) { return value ? JSON.stringify(value) : ''; }
  function create(win) {
    var current = null, revision = 0, manualEdits = 0, confirmed, lastEmitted, queue = Promise.resolve(), pending = new Map();
    try { current = normalize(win.localStorage.getItem(KEY)); } catch (error) { /* Quota/privacy denial must not block manual entry. */ }
    var route = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/';
    if (typeof route !== 'string' || route.charAt(0) !== '/') route = '/';
    route = route.replace(/\/+$/, '') + '/';
    function saveLocal() {
      try {
        if (current) win.localStorage.setItem(KEY, signature(current));
        else win.localStorage.removeItem(KEY);
      } catch (error) { /* Cart attribute is the durable fallback when storage is blocked/full. */ }
    }
    function publish() {
      var next = signature(current);
      if (next === lastEmitted) return;
      lastEmitted = next;
      win.document.dispatchEvent(new win.CustomEvent('k2:shipping-destination', { detail: clone(current) }));
    }
    function apply(value) {
      if (signature(value) === signature(current)) return false;
      current = clone(value);
      revision += 1;
      saveLocal();
      publish();
      return true;
    }
    async function cartRequest(path, options) {
      var controller = typeof win.AbortController === 'function' ? new win.AbortController() : null;
      var timer = controller ? win.setTimeout(function () { controller.abort(); }, 8000) : null;
      try {
        var response = await win.fetch(route + path, Object.assign({ credentials: 'same-origin' }, options, controller ? { signal: controller.signal } : {}));
        if (!response.ok) throw new Error('Shipping destination could not be saved.');
        return await response.json();
      } finally { if (timer !== null) win.clearTimeout(timer); }
    }
    function persist(address, atRevision) {
      var value = signature(address), key = atRevision + '|' + value;
      if (value === confirmed && pending.size === 0) return Promise.resolve(clone(address));
      if (pending.has(key)) return pending.get(key);
      var result = queue.catch(function () {}).then(async function () {
        // A queued older edit cannot overwrite a newer manual ZIP.
        if (atRevision !== revision) return clone(current);
        if (value === confirmed) return clone(address);
        var attributes = {}; attributes[KEY] = value;
        var cart = await cartRequest('cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attributes }) });
        var returned = normalize(cart && cart.attributes && cart.attributes[KEY]);
        if (signature(returned) !== value) throw new Error('Shipping destination could not be saved.');
        confirmed = value;
        return clone(address);
      });
      queue = result;
      pending.set(key, result);
      result.then(function () { pending.delete(key); }, function () { pending.delete(key); });
      return result;
    }
    var service = {
      get: function () { return clone(current); },
      set: function (address) {
        var next = normalize(address);
        if (address !== null && !next) return Promise.reject(new Error('Enter a valid US ZIP code.'));
        manualEdits += 1;
        if (!apply(next)) saveLocal();
        return persist(next, revision);
      }
    };
    var initialRevision = revision, initialManualEdits = manualEdits;
    service.ready = cartRequest('cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
      if (revision !== initialRevision || manualEdits !== initialManualEdits) return service.get();
      var saved = normalize(cart && cart.attributes && cart.attributes[KEY]);
      confirmed = signature(saved);
      if (saved) apply(saved);
      else if (current) persist(current, revision).catch(function () {});
      return service.get();
    }).catch(function () { return service.get(); }).then(function () {
      // One readiness event also reaches a PDP initialized before this deferred script.
      publish();
      return service.get();
    });
    return service;
  }
  return { key: KEY, normalize: normalize, create: create };
});
